import "./styles.scss";

import React, { Fragment } from "react";
import { Link, useHistory } from "react-router-dom";

import Button from "../Buttons";

const Footer = () => {
  const history = useHistory();
  const isFooterHidden = ["preview-event", "test"].some((route) => history.location.pathname.includes(route)) || window ? "parentIFrame" in window : false;

  return (
    <Fragment>
      <footer className="golf-footer" style={{ display: isFooterHidden ? "none" : "block" }}>
        <div className="golf-container d-flex flex-wrap">
          <div className="is-1-of-1 sm_tablet:is-1-of-4 d-flex mb-32 sm_tablet:mb-0">
            <Link to={"/"} className="golf-footer__logo--orange"></Link>
          </div>
          {false && (
            <div className="is-1-of-2 sm_tablet:is-1-of-4">
              <ul className="golf-footer__links-wrapper">
                <li className="golf-footer__list-title mb-20">
                  <p>Company</p>
                </li>
                <li>
                  <Link to={"/about"} className="golf__link golf-footer__link mb-20">
                    <span>About</span>
                  </Link>
                </li>
                <li>
                  <Link to={"/contact"} className="golf__link golf-footer__link mb-20">
                    <span>Contact</span>
                  </Link>
                </li>
                <li>
                  <Link to={"/faq"} className="golf__link golf-footer__link mb-20">
                    <span>FAQ</span>
                  </Link>
                </li>
              </ul>
            </div>
          )}
          <div className="is-1-of-1 sm_tablet:is-3-of-4 d-flex items-center">
            <ul className="golf-footer__links-wrapper d-flex sm_tablet:ml-auto">
              <li>
                <a
                  href={process.env.REACT_APP_BASE_URL == "prod" ? "https://www.golfgenius.com/terms_conditions" : "https://ggstest.com/terms_conditions"}
                  target="_blank"
                  rel="noreferrer"
                  className="golf__link golf-footer__link"
                >
                  <span>Terms of Use</span>
                </a>
              </li>
              <li className="ml-16 sm_tablet:ml-64">
                <a
                  href={process.env.REACT_APP_BASE_URL == "prod" ? "https://golfgenius.com/privacy" : "https://ggstest.com/privacy"}
                  target="_blank"
                  rel="noreferrer"
                  className="golf__link golf-footer__link"
                >
                  <span>Privacy Policy</span>
                </a>
              </li>
            </ul>
          </div>
          {false && (
            <div className="is-1-of-1 sm_tablet:is-1-of-4">
              <div className="golf-footer__newsletter">
                <p className="golf-footer__list-title mb-20">Newsletter</p>
                <form action="" className="golf-footer__subscribe-form" autoComplete={"off"}>
                  <label className="golf-footer__subscribe-label mb-4" htmlFor="">
                    Your email
                  </label>
                  <input placeholder={"Type your email"} className={"golf-footer__subscribe-input mb-12"} type="text" autoComplete={"new-password"} />
                  <Button type={"secondary-outline-blue"} label={"Subscribe"} />
                </form>
              </div>
            </div>
          )}
        </div>
      </footer>
    </Fragment>
  );
};

export default Footer;
